// src/component/layouts/FormLayout.js
import { Outlet } from "react-router-dom";

export default function FormLayout() {
  return <Outlet />;
}
